import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
var InterimReturnTitle = function (_a) {
    var index = _a.index, firstInitializedReturnIndex = _a.firstInitializedReturnIndex;
    if (index !== firstInitializedReturnIndex)
        return React.createElement("div", { className: "sui-hidden md:sui-block" });
    return (React.createElement("div", null,
        React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Returned Items")));
};
export default InterimReturnTitle;
